module.exports = __webpack_public_path__ + "static/media/15.928bf1c3.jpg";